<script setup lang="ts">
defineProps({
  conversation: null
})

const { navigateToConversation } = useNavigation()
const { addConversationsToSidebar, removeConversationsFromSidebar, sidebarFavoriteConversations } = useSidebar()
const { deleteConversation } = useConversations()
</script>

<template>
  <div>
    <menu-section>
      <dropdown-item @click="navigateToConversation(conversation)">
        View in full-width
      </dropdown-item>
      <menu-separator />
      <dropdown-item
        v-if="!!sidebarFavoriteConversations[conversation.id]"
        @click="removeConversationsFromSidebar({ [conversation.id]: conversation })"
      >
        Remove favorite
      </dropdown-item>
      <dropdown-item
        v-else
        @click="addConversationsToSidebar({ [conversation.id]: conversation })"
      >
        Add to favorites
      </dropdown-item>
      <menu-separator />
      <dropdown-item
        @click="deleteConversation(conversation.id)"
      >
        <span class="delete-warning">Delete this conversation</span>
      </dropdown-item>
    </menu-section>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.delete-warning
  @apply font-medium text-$global-red-primary

.icon-item
  @apply inline-flex gap-1 inline-center items-center
  .icon
    @apply w-4 h-4 flex items-center justify-center
</style>
